import { Decimal } from '@snap-types/types/decimal';

export function calculateTotal(quantity: Decimal, unitValue: Decimal) {
  return unitValue.times(quantity);
}
